export default __webpack_public_path__ + "static/media/person_3.c4cb6dfa.jpg";